import { render } from "./EvaluationUserTestsView.vue?vue&type=template&id=1d0f063a"
import script from "./EvaluationUserTestsView.vue?vue&type=script&lang=js"
export * from "./EvaluationUserTestsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__